import React from 'react';
import { Nav, Image } from 'react-bootstrap';


import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import { isMobile } from 'react-device-detect';

// IMAGES
import WhatsApp01 from "../images/svgs/SocialMediaMenu/Whatsapp01.svg";
import Phone01 from "../images/svgs/SocialMediaMenu/Phone01.svg";
import Instagram01 from "../images/svgs/SocialMediaMenu/Instagram01.svg";
import Snapchat01 from "../images/svgs/SocialMediaMenu/Snapchat01.svg";
import Twitter01 from "../images/svgs/SocialMediaMenu/Twitter01.svg";
import Youtube from "../images/svgs/Youtube.svg";
import Location01 from "../images/svgs/SocialMediaMenu/Location01.svg"
class Footer extends React.Component {
  render() {
    const translate = this.props.translate
    return (

      <div
        className="container footerDiv"
        style={{
          background:
            !this.props.imagesList || this.props.imagesList.length === 0 ? 'transparent' : '#f4f4f4',
        }}
      >
        <div className={"footerRow"} >
          {this.props.instagramAccountInfo.youtube_handle && (

            <Nav.Link
              href={this.props.instagramAccountInfo.youtube_handle}
              target="_blank"
              rel="noopener noreferrer"
              id="youtubelink"
              className="columnDiv footerButtons"
            >
              <Image
                className="socialButtonImages socialButtonLogo"
                src={Youtube}
              />
            </Nav.Link>

          )}
          {this.props.instagramAccountInfo.telephoneNumber && (

            <a
              href={`tel:${this.props.instagramAccountInfo.telephoneNumber}`}
              id="telephoneNumber"
              className="navLink columnDiv footerButtons"

            >
              <Image
                className="socialButtonImages"
                src={Phone01}
              />
            </a>

          )}
          {(this.props.instagramAccountInfo.insta_handle && (this.props.pathname === "/" ||
            this.props.pathname === "/ar" || this.props.pathname === "/instagram")
            && (

              <Nav.Link
                href={this.props.instagramAccountInfo.instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                id="instagramLink"
                onClick={() => {
                  if (
                    !isNull(this.props.instagramAccountInfo.snap_pixel_script) &&
                    !isEmpty(this.props.instagramAccountInfo.snap_pixel_script) &&
                    this.props.instagramAccountInfo.snap_pixel_script) {
                    window.snaptr('track', 'VIEW_CONTENT')
                  }


                  return true
                }}
                className="navLink columnDiv footerButtons"

              >
                <Image className="socialButtonImages" src={Instagram01} />

              </Nav.Link>


            ))}
          {this.props.instagramAccountInfo.snapchat_handle &&
            (this.props.pathname === "/" || this.props.pathname === "/ar" ||
              this.props.pathname === "/snap"
            ) && (

              <a
                href={`https://www.snapchat.com/add/${this.props.instagramAccountInfo.snapchat_handle}`}
                target="_blank"
                rel="noopener noreferrer"
                id="snapchatLink"
                className="navLink columnDiv footerButtons"

              >
                <Image
                  className="socialButtonImages"
                  // src="assets/images/svgs/snapchatGhost.svg"
                  src={Snapchat01}
                />
              </a>

            )}
          {this.props.instagramAccountInfo.twitter_handle && (
            <a
              href={`https://twitter.com/${this.props.instagramAccountInfo.twitter_handle}`}
              target="_blank"
              rel="noopener noreferrer"
              id="twitterLink"
            >
              <Image
                className="socialButtonImages socialButtonLogo"
                src={Twitter01}
              />
            </a>


          )}
          {this.props.instagramAccountInfo.googlemaplink && (

            <a
              href={
                this.props.instagramAccountInfo.googlemaplink
                // this.props.instagramAccountInfo.businessName === 'willcafe'
                // 	? 'https://maps.app.goo.gl/q72cWJniwwvxGA5s9'
                // 	: this.props.instagramAccountInfo.businessName === 'lampo'
                // 	? 'https://goo.gl/maps/aegDT4rzUerq4Tkn9'
                // 	: ''
              }
              target="_blank"
              rel="noopener noreferrer"
              id="googleMapLink"
              className="navLink columnDiv footerButtons"

            >
              <Image className="socialButtonImages" src={Location01} />
            </a>

          )}
          {this.props.instagramAccountInfo.whatsappnumber && (

            <a
              // href={this.props.instagramAccountInfo.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              id="whatsappLink"
              onClick={() => {
                if (isMobile) {
                  window.open(`whatsapp://send?phone=${this.props.instagramAccountInfo.whatsappnumber}`)
                } else {
                  window.open(this.props.instagramAccountInfo.whatsappLink)
                }
                return true
              }}
              className="navLink columnDiv footerButtons"

            >
              <Image className="socialButtonImages" src={WhatsApp01} />
            </a>

          )}
        </div>
        <div className="row" style={{ marginBottom: 15, marginTop: 10 }}>

          <p className={`poweredSlideText ${this.props.language === "ar" && "arabic"}`}>
            {translate[`This site is Powered by Optimize App`]}
          </p>

          <a
            href="https://app.adjust.com/fw3cwi8?label=OptimizeShop&redirect=https%3A%2F%2Fwww.optimizeapp.com%2Fdownload"
            target="_blank"
            rel="noopener noreferrer"
            className={`getYoursText ${this.props.language === "ar" && "arabic"}`}>
            {translate[`Get yours now!`]}
          </a>


        </div>


      </div>

    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/SubscribedFooter.js